<template>
  <div>
    <Headersys />
    <div class="content">
      <div>
        汉王签字板
      </div>
      <el-button type="primary" @click="startSign('HWInitialize')">开始签名</el-button>
      <el-button type="success" @click="finish('HWFinalize')">清除窗口笔记</el-button>
      <el-button type="info" @click="finish('HWClearSign')">结束签名</el-button>
      <el-button type="warning" @click="finish('HWGetSign')">获取笔迹图片</el-button>
      <el-button type="danger" @click="finish('HWGetDeviceId')">获取设备序列号</el-button>
      <el-button @click="websopen">开启</el-button>
      <el-button @click="close">关闭</el-button>
      <img class="signImg" :src="signImg" alt="">
      <div class="idcard-title" @dblclick="clear">
        <div v-for="(item, idx) in msgList" :key="idx">
          {{ item }}
        </div>
      </div>
    </div>
    <Back />
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      //29999
      wsUri: "ws://127.0.0.1:29999",//汉王签字版链接
      webSkt: null,
      msgList: [],
      signImg: ""
    };
  },
  created() {
  },
  mounted() {
    // this.websopen()
  },
  // destroyed() {
  //   this.webSkt.close()
  // },
  methods: {
    // 开始签名
    startSign() {
      var data = {
        "HWPenSign": 'HWInitialize',
        "key": "D9063E7FE567E09E84B00B5ECDE9B3F2",
        "title": "请在签字板上签名",
        "nOrgX": 300,
        "nOrgY": 300,
        "nWidth": 500,
        "nHeight": 300,
        "nImageWidth": -1,
        "nImageHeight": -1,
        "nFingerCap": 0,
        "nConfirmTimeout": 20
      }

      this.doSend(JSON.stringify(data));
    },
    finish(HWPenSign) {
      var data = {
        HWPenSign
      }
      this.doSend(JSON.stringify(data));
    },
    // 建立websocket链接
    websopen() {
      this.webSkt = new WebSocket(this.wsUri);
      this.webSkt.onopen = (evt) => {
        console.log('汉王签字版就绪', evt);
        this.msgList.push('汉王签字版就绪')
      };
      this.webSkt.onmessage = (evt) => {
        this.msgList.push(evt.data)
        var jsondata = JSON.parse(evt.data);
        this.onMessage(jsondata)
      };
      this.webSkt.onerror = (evt) => {
        console.log('汉王签字板报错', evt);
        this.msgList.push('汉王签字板未连接')
      };
    },
    doSend(message) {
      // { HWPenSign } 传参Key
      // HWInitialize  开始签名
      // HWFinalize    清除窗口笔记
      // HWClearSign   结束签名
      // HWGetSign     获取笔迹图片
      // HWGetDeviceId 获取设备序列号
      this.webSkt.send(message);
    },
    onMessage(jsondata) {
      // var jsondata = JSON.parse(evt.data);
      console.log('返回信息', jsondata);
      if (jsondata.HWPenSign == "HWGetSign" && jsondata.msgID == "0") {
        this.signImg = jsondata.message
      }
    },
    close() {
      this.webSkt.close();
    },
    clear() {
      this.msgList = []
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  overflow-y: scroll;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.idcard-title {
  min-height: 20vh;
  padding: 10px;
  border: 1px solid #ff0000;
  font-size: 6rem;
}

.signImg {
  width: 100rem;
}
</style>